import src from "IMAGE";
export default { src, width: 186, height: 50, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/ACgoKBJubm4uNjY2IDo6OixJSUk6Tk5OOT4+PiwVFRUPADk5OR2dnZ1OTU1NL1lZWUJaWlpDcnJySmhoaD0mJiYWFeIRSUCBJJMAAAAASUVORK5CYII="};
